import React, { useEffect, useState, Fragment } from 'react';
import { useDataContext } from '../context/data';
import translations from '../constants/translations.json';
import ReactCountryFlag from 'react-country-flag';
import { Menu, Transition } from '@headlessui/react';
import { languageToCountry } from '../utils/language';

const LanguageSelectorDropdown = ({ className = '', isMobile = false }) => {
  let pathname = window.location.pathname;
  const restaurantId = pathname.split('/')?.[2];

  const { language, setLanguage, setLanguageFromRestaurant } = useDataContext();
  const [selectedLanguage, setSelectedLanguage] = useState(null);

  // Create language options
  const languageOptions = Object.entries(translations).map(([langCode, value]) => {
    const countryCode = languageToCountry(langCode);

    return {
      value: langCode,
      countryCode: countryCode || 'US',
      languageName: value.language_name,
    };
  });

  useEffect(() => {
    // Set the selected language option based on current effective language
    const currentOption = languageOptions.find((option) => option.value === language);
    setSelectedLanguage(currentOption);
  }, [language]);

  const changeLanguage = (selectedOption) => {
    setSelectedLanguage(selectedOption);
    setLanguage(selectedOption.value);
    window.localStorage.setItem('user_lang', selectedOption.value);

    if (restaurantId) {
      setLanguageFromRestaurant(null, selectedOption.value);
    }
  };

  return (
    <div
      className={`language-selector-wrapper ${className}`}
      style={{ width: isMobile ? '100%' : '65px' }}
    >
      <Menu as="div" className="relative">
        {({ open }) => (
          <>
            <Menu.Button className="relative w-full py-2 pl-3 pr-6 text-left bg-gray-100 rounded-full cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-blue-500 transition-all hover:bg-gray-200">
              {selectedLanguage && (
                <div className="flex items-center justify-center selected-language">
                  <ReactCountryFlag
                    countryCode={selectedLanguage.countryCode}
                    svg
                    style={{ width: '1.5rem' }}
                  />
                  {isMobile && <span className="ml-2">{selectedLanguage.languageName}</span>}
                </div>
              )}

              <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <i
                  className={`fas ${
                    open ? 'fa-chevron-up' : 'fa-chevron-down'
                  } text-xs text-gray-400`}
                />
              </span>
            </Menu.Button>

            <Menu.Items className="absolute right-0 md:left-0 mt-2 w-40 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
              {languageOptions.map((option) => (
                <Menu.Item key={option.value}>
                  {({ active }) => (
                    <div
                      onClick={() => changeLanguage(option)}
                      className={`${active ? 'bg-gray-100' : 'text-gray-900'} ${
                        selectedLanguage && selectedLanguage.value === option.value
                          ? 'bg-blue-50'
                          : ''
                      } cursor-pointer select-none relative py-2 pl-3 pr-4`}
                    >
                      <div className="flex items-center language-option">
                        <ReactCountryFlag
                          countryCode={option.countryCode}
                          svg
                          style={{ width: '1.2rem', height: '1.2rem', marginRight: '8px' }}
                        />
                        <span className="text-sm sm:text-base">{option.languageName}</span>
                      </div>
                    </div>
                  )}
                </Menu.Item>
              ))}
            </Menu.Items>
          </>
        )}
      </Menu>
    </div>
  );
};

export default LanguageSelectorDropdown;
